import React from 'react'
import logo from '../../../assets/images/logo.png'
import playStore from '../../../assets/images/icons/google-play-badge.png'
import Right_arraw from '../../../assets/images/arrow_gold.png'
import right_arrow_white from '../../../assets/images/right_arrow_white.png'
import { useSelector, useDispatch } from 'react-redux'
import { Logout } from 'service/apis/customer.apis'
import { AddCart, StoreUserData } from 'redux/actions/productAction'
import { BsArrowRightShort } from 'react-icons/bs'
import { history } from 'redux/store/store'
import { BiRightArrowAlt } from 'react-icons/bi'
import fb from '../../../assets/svg/Facebook.svg'
import fbFill from '../../../assets/svg/Facebook-Fill.svg'
import insta from '../../../assets/svg/Insta.svg'
import instaFill from '../../../assets/svg/Insta-Fill.svg'
import youtube from '../../../assets/svg/Youtube.svg'
import youtubeFill from '../../../assets/svg/Youtube-Fill.svg'
import { useEffect, useState } from 'react'

// import fb_logo from '../../../assets/images/fb_logo.png'
// import insta_logo from '../../../assets/images/instagram_logo.png'
// import linkedin_logo from '../../../assets/images/lindedin_logo.png'
// import newsfeed_logo from '../../../assets/images/newsfeed_logo.png'
// import youtube_logo from '../../../assets/images/youtube_logo.png'
// import down_button from '../../../assets/images/down_button.png'
// import { useSelector } from "react-redux";
// import flag from '../../../assets/images/flag.png'

function FooterBlockComp(props) {
  // const userData=useSelector
  const userData = useSelector((state) => state?.task?.userData)
  const [yearNow, setYearNow] = useState('')

  useEffect(() => {
    const currentYear = new Date().getFullYear()
    setYearNow(currentYear)
  }, [])

  const dispatch = useDispatch()
  const LogoutUser = async () => {
    try {
      let { data } = await Logout({
        customerAccessToken: userData?.accessToken
      })
      history.push('/')
      dispatch(
        StoreUserData({
          emailId: '',
          phoneNumber: '',
          accessToken: '',
          cartData: {}
        })
      )
      dispatch(AddCart([]))
    } catch (err) { }
  }

  return (
    <>
      <div id='footerBlock' className={'bg-grey-ee ' + props.className || ''}>
        <div className='text-left py-5 row footer-pdng'>
          <div className='col-sm-5 col-12 text-left'>
            {/* <img
              src={logo}
              alt=''
              style={{
                width: '169.41px'
              }}
            /> */}
            <h4 className='text-left main--title varies'>VB DACE | Redefine your Cooking Experience</h4>
            <p className='pb-2 col-sm-12 col-11 px-0' style={{ fontSize: '14px' }}>
              Elevate your Cooking Experience with our heirloom collection of non-toxic, sustainable Kitchenware. Combining timeless craftsmanship with cutting-edge technology, we empower you with elegant, precise, and health-focused solutions for all your culinary needs.
            </p>
            {/* <h4 className='text-left main--title'>The man behind VB DACE</h4>
            <p className='pb-2 col-sm-12 col-11 px-0' style={{ fontSize: '14px' }}>
              The Celebrity Chef Venkatesh Bhat, is one of his kind and is revered by millions of home chefs, not just for his foolproof recipes, but also for all the small nuances and tricks he shares, that aid in recreating his recipes with the same magic.
            </p> */}
            <h3></h3>
            <div className='d-flex align-items-center m-0 mb-3'>
              <a
                href='https://play.google.com/store/apps/details?id=com.vbdace.app'
                target='_blank'
              >
                <img alt='' width='146' className='img-fluid' src={playStore} />
              </a>
            </div>
          </div>
          <div className='col-sm-7 col-12'>
            <div className='row'>

              <div className='col-sm-3 col-6 pb-4 pb-sm-0 px-0'>
                <p className='font-weight-bold my-sm-auto my-1 pb-8px'>Policies</p>
                <ul>
                  <li className='size-14'>
                    <a
                      href={`/static/${'return-policy'}`}
                      className='text-decoration-none text-reset hand'
                    >
                      Returns Policy
                    </a>
                  </li>
                  <li className='size-14'>
                    <a
                      href={`/static/${'terms-use'}`}
                      className='text-decoration-none text-reset hand'
                    >
                      Terms of Use
                    </a>
                  </li>

                  <li className='size-14'>
                    <a
                      href={`/static/${'privacy-policy'}`}
                      className='text-decoration-none text-reset hand'
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li className='size-14'>
                    <a
                      href={`/static/${'cookie-policy'}`}
                      className='text-decoration-none text-reset hand'
                    >
                      Cookie Policy
                    </a>
                  </li>
                  <li className='size-14'>
                    <a
                      href={`/static/${'shipping'}`}
                      className='text-decoration-none text-reset hand'
                    >
                      Shipping & delivery
                    </a>
                  </li>
                </ul>
              </div>
              <div className='col-sm-3 col-6 px-0'>
                <p className='font-weight-bold my-sm-auto my-1 pb-8px'>Company</p>
                <ul>

                  <li className='size-14'>
                    <a
                      href={`/static/${'about'}`}
                      className='text-decoration-none text-reset'
                    >
                      About VB Dace
                    </a>
                  </li>

                  <li className='size-14'>
                    <a
                      href="contact-us"
                      className='text-decoration-none text-reset'
                    >
                      Contact Us
                    </a>
                  </li>

                  <li className='size-14'>
                    <a
                      href="/our-experience-centers"
                      className='text-decoration-none text-reset'
                    >
                      Our Experience Centers
                    </a>
                  </li>

                </ul>
              </div>
              <div className='col-sm-4 col-6 px-0 m-0'>
                {userData?.accessToken === '' ? (
                  <div className='signIn-container'>
                    <p className='font-weight-bold my-sm-0 my-1 pb-8px'>My Account</p>
                    <span className='mb-2 d-block'>
                      Log In or Create an Account
                    </span>

                    <a
                      href='/auth/login'
                      className='btn mb-2 w-100 rounded-0 btn-outline-dark py-1 text-left d-flex'
                      style={{ marginTop: '1rem' }}
                    >
                      Log In{' '}
                      <span className='ml-auto'>
                        <BsArrowRightShort size={25} className='ml-3' />
                        {/* <img src={Right_arraw} alt="" /> */}
                      </span>
                    </a>
                    <a
                      href='/auth/signup'
                      className='btn mb-2 rounded-0 btn-dark py-1 text-left d-flex'
                    >
                      Create an account{' '}
                      <span className='ml-auto'>
                        <img src={right_arrow_white} alt='' />
                      </span>
                    </a>
                  </div>
                ) : (
                  <span
                    onClick={LogoutUser}
                    className='btn mb-2 w-100 rounded-0 btn-outline-dark py-1 text-left d-flex align-items-center'
                  >
                    Logout{' '}
                    <span className='ml-auto'>
                      <BsArrowRightShort size={25} className='ml-3' />
                      {/* <img src={right_arrow_white} alt="" /> */}
                    </span>
                  </span>
                )}

                <div className="d-flex align-items-sm-start align-items-center text-start mt-3">

                  <a href="https://www.facebook.com/vbdace.store" target='_blank' className="mr-1 social-icons fbIconContainer">
                    <img src={fb} alt='' className='fbIcon' />
                    <img src={fbFill} alt='' className='fbFillIcon' />
                  </a>

                  <a href="https://www.instagram.com/vbdace.store/" target='_blank' className="mx-1 social-icons instaIconContainer">
                    <img src={insta} alt='' className='instaIcon' />
                    <img src={instaFill} alt='' className='instaFillIcon' />
                  </a>

                  <a href="https://www.youtube.com/@vbdacestore" target='_blank' className="mx-1 social-icons youTubeIconContainer">
                    <img src={youtube} alt='' className='youTubeIcon' />
                    <img src={youtubeFill} alt='' className='youTubeFillIcon' />
                  </a>

                </div>

              </div>

            </div>
          </div>
        </div>
        <div className='py-sm-3 border-bottom col-12 border-d2 d-none-mob'>

          <div className='col-12 d-sm-none p-0'>
            {userData?.accessToken === '' ? (
              <>
                <p className='font-weight-bold my-sm-0 my-1'>My Account</p>
                <span className='mb-2 d-block'>
                  Log In or Create an Account
                </span>
                <a
                  href='/auth/login'
                  className='btn mb-2 w-100 rounded-0 btn-outline-dark py-1 text-left d-flex align-items-center'
                >
                  Log In{' '}
                  <span className='ml-auto'>
                    <img src={Right_arraw} alt='' />
                  </span>
                </a>
                <a
                  href='/auth/signup'
                  className='btn mb-2 rounded-0 bg-gradient text-light shadow py-1 text-left d-flex align-items-center'
                >
                  Create an account{' '}
                  <span className='ml-auto'>
                    <img src={right_arrow_white} alt='' />
                  </span>
                </a>
              </>
            ) : (
              <div>
                <div className='col-6'>
                  <button className='logoutBtn'>
                    <div className='d-flex justify-content-between'>
                      <div
                        onClick={LogoutUser}
                        className='d-flex justify-content-start'
                      >
                        Logout
                      </div>
                      <div className='d-flex justify-content-end align-items-center'>
                        <BiRightArrowAlt color='#ab7c62' size={20} />
                      </div>
                    </div>
                  </button>
                </div>
              </div>
              // <div className="d-flex justify-content-start text-left">
              //   <div className="col-12 text-left">

              //     <span
              //       onClick={LogoutUser}
              //       className="btn mb-2 rounded-0 btn-outline-dark py-1 text-left d-flex align-items-center"
              //     >
              //       Logout{" "}
              //       <span className="ml-auto">
              //         <img src={right_arrow_white} alt="" />
              //       </span>
              //     </span>
              //   </div>
              // </div>
            )}
          </div>
          {/* <p className='text-sm-right text-center py-2'>Click to change country <span>IND <img src={flag} style={{ marginTop: "-5px" }} alt="" /> <img className='ml-1' style={{ marginTop: "-4px" }} src={down_button} alt="" /></span></p> */}
        </div>
        <div className='pb-5 pt-3 text-center text-sm-left'>
          <span>
            © {yearNow} VB Dace Appliances Private Limited. <span className='mob-block'>All rights reserved.</span>
          </span>
        </div>
      </div>

      <div className='whatsAppIcon'>
        <a target='_blank' href='https://wa.me/+918610684068'> <img src='https://cdn.shopify.com/s/files/1/0616/7222/6982/files/whatsapp.png?v=1693917497' alt='' /></a>
      </div>
    </>
  )
}

export const FooterBlock = FooterBlockComp
